import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { storage } from "../shared/utils/storage";
import { STORAGE_KEYS } from "../config/keys";

export type ThemeMode = "light" | "dark";

interface ThemeState {
  mode: ThemeMode;
}

const initialState: ThemeState = {
  mode: storage.get(STORAGE_KEYS.THEME, "light"),
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload;
      storage.set(STORAGE_KEYS.THEME, action.payload);
    },
    toggleTheme: (state) => {
      const newMode = state.mode === "light" ? "dark" : "light";
      state.mode = newMode;
      storage.set(STORAGE_KEYS.THEME, newMode);
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
